import { pharmacyInventoryApi } from "./inventory-api";

/** Référence ISC stable par ligne de consommable patient. */
export function consumableChargeReservationRef(chargeId: string, lineId: string): string {
  return `consumables:charge:${chargeId}:${lineId}`;
}

export async function reserveConsumableChargeLine(
  chargeId: string,
  line: { id: string; productId: string; quantity: number },
  storeId: string,
): Promise<void> {
  await pharmacyInventoryApi.upsertReservation({
    productId: line.productId,
    storeId,
    quantity: line.quantity,
    externalRef: consumableChargeReservationRef(chargeId, line.id),
  });
}

export async function releaseConsumableChargeLine(
  chargeId: string,
  line: { id: string },
): Promise<void> {
  await pharmacyInventoryApi.releaseReservation(
    consumableChargeReservationRef(chargeId, line.id),
  );
}

export async function issueConsumableChargeLinesAtomically(
  chargeId: string,
  lines: Array<{ id: string; productId: string; quantity: number }>,
  storeId: string,
): Promise<void> {
  if (lines.length === 0) return;
  await pharmacyInventoryApi.postIssueBatch({
    reference: `CONS-CHG-${chargeId.slice(-8)}`,
    lines: lines.map((line) => ({
      productId: line.productId,
      quantity: line.quantity,
      sourceStoreId: storeId,
      externalRef: consumableChargeReservationRef(chargeId, line.id),
    })),
  });
}
